import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { CommandResult } from '@app/_models/command/commandResult';
import { UserContractDto } from '@app/_models/userContractDto';
import { UserContractsRequestDto } from '@app/_models/userContractsRequestDto';
import { BaseApiService } from './baseApi.service';

@Injectable({
  providedIn: 'root',
})
export class UserContractService extends BaseApiService {
  protected readonly http = inject(HttpClient);

  private readonly currentUserSource = new ReplaySubject<UserContractDto>(1);
  currentUser$ = this.currentUserSource.asObservable();

  constructor() {
    super('usercontract');
  }

  getUserContracts(userId?: string): Observable<UserContractDto[]> {
    let path = '/contracts';
    if (userId) {
      path = `/${userId}/contracts`;
    }
    return this.http.get<UserContractDto[]>(this.baseControllerUrl + path);
  }

  canCloseContracts(): Observable<boolean> {
    return this.http.get<boolean>(this.baseControllerUrl + '/can-close-contracts');
  }

  validateApplyUserContracts(userContractsRequestDto: UserContractsRequestDto): Observable<CommandResult> {
    return this.http.post<CommandResult>(this.baseControllerUrl + '/apply/validate', userContractsRequestDto);
  }

  validateConfirmUserContracts(userContractsRequestDto: UserContractsRequestDto): Observable<CommandResult> {
    return this.http.post<CommandResult>(this.baseControllerUrl + '/confirm/validate', userContractsRequestDto);
  }

  validateUserDeclineUserContracts(userContractsRequestDto: UserContractsRequestDto): Observable<CommandResult> {
    return this.http.post<CommandResult>(this.baseControllerUrl + '/decline/validate', userContractsRequestDto);
  }

  validateTerminateUserContracts(userContractsRequestDto: UserContractsRequestDto): Observable<CommandResult> {
    return this.http.post<CommandResult>(this.baseControllerUrl + '/terminate/validate', userContractsRequestDto);
  }

  applyUserContracts(userContractsRequestDto: UserContractsRequestDto): Observable<CommandResult> {
    return this.http.post<CommandResult>(this.baseControllerUrl + '/apply', userContractsRequestDto);
  }

  confirmUserContracts(userContractsRequestDto: UserContractsRequestDto): Observable<CommandResult> {
    return this.http.post<CommandResult>(this.baseControllerUrl + '/confirm', userContractsRequestDto);
  }

  userDeclineUserContracts(userContractsRequestDto: UserContractsRequestDto): Observable<CommandResult> {
    return this.http.post<CommandResult>(this.baseControllerUrl + '/decline', userContractsRequestDto);
  }

  terminateUserContracts(userContractsRequestDto: UserContractsRequestDto): Observable<CommandResult> {
    return this.http.post<CommandResult>(this.baseControllerUrl + '/terminate', userContractsRequestDto);
  }
}
